import React from 'react';

import clsxm from '@/lib/clsxm';

type Logo = React.ComponentType<{ className?: string }>;

/**
 * A model maker's logo. Several are drawn in black (OpenAI keeps its own
 * dark-mode class only until a size class replaces it), so in dark mode the
 * logo sits on a small white tile instead of vanishing into the background.
 * Size it with `className` (h-4 w-4, h-5 w-5…).
 */
export const ModelLogo = ({
  icon: Icon,
  className,
}: {
  icon: Logo;
  className?: string;
}) => (
  <span
    aria-hidden
    className={clsxm(
      'inline-flex h-4 w-4 flex-none items-center justify-center rounded text-gray-900 dark:bg-white dark:p-[2px]',
      className,
    )}
  >
    <Icon className='h-full w-full' />
  </span>
);

export default ModelLogo;
